<template>
    <v-app v-if="!dataOnlyPage">
        <app-mobile-menu
            v-if="userOnSecurePage && $vuetify.breakpoint.mdAndDown"
        />

        <template v-if="userOnSecurePage">
            <app-header :overlay.sync="overlay"></app-header>
            <div class="ribbon text-center pb-4" v-if="ribbon">
                <div class="glass d-flex justify-sm-center pt-2">
                    <img src="/images/announce.png" height="20" class="mr-1 mr-sm-2" />
                    <p class="my-0" v-html="ribbon" />
                </div>
            </div>
        </template>
        <v-overlay :value="overlay" :zIndex="3" v-if="$vuetify.breakpoint.smAndDown" />

        <div id="BgImgContainer">
            <!-- @TODO Stop this from continually bugging me because it is not there. -->
            <v-img
                id="BgImg"
                src="/svg/kaoshi-light-bg.svg"
            >
            </v-img>
        </div>

        <!-- Sizes your content based upon application components -->
        <v-content>
            <router-view></router-view>
        </v-content>
        <div id="swal-app-container"></div>
        <div id="flow-video-container">
            <div />
        </div>

        <CaptchaDialog />
    </v-app>
    <v-app v-else>
        <router-view></router-view>
        <div id="flow-video-container">
            <div />
        </div>
    </v-app>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import FormFillerService from '../../services/FormFillerService';
    import MySocket from '../../services/MySocket';
    import vuetify from 'vuetify';
    import 'vuetify/dist/vuetify.min.css';
    import CaptchaDialog from '../components/CaptchaDialog';

    export default {
        data,
        mounted,
        computed: getComputed(),
        watch: getWatchers(),
        components: {
          CaptchaDialog,
        },
        methods: {
            ...mapActions('countries', [
                'loadKaoshiCountries',
            ]),
            async getRibbon() {
                try {
                    const { data } = await Vue.backendApi().ribbons().getActive();
                    Vue.set(this, 'ribbon', data.content);
                } catch (err) {
                    console.log('Error loading ribbon', err);
                }
            },
        },
    };

    function getWatchers() {
        return {
            isOnSecurePage: async (val) => {
                if (!MySocket) {
                    console.warn('MySocket returned a falsy value - no socket _at all_!');
                    return;
                }

                if (val) {
                    console.log('Attempting to connect the socket.');
                    await MySocket.connectSocket();
                    return;
                }

                console.log('Val was not truthy so trying to disconnect socket.');
                MySocket.disconnect();
            },
        };
    }

    function mounted() {
        const vm = this;

        /**
         * NOTE: It does not look good, but I decided to do that, some users have localStorage
         * full of emails and i decided to clean it up every time, instead of asking every user
         * to clear the cache and i devided to clean it up every time, instead of asking every
         * user to clear the cache - https://trello.com/c/ySPAaC2w
         */
        vm.$store.state.emails = null;

        // Start the session check timer.
        vm.$store.dispatch('startSessionCheckTimer', vm);

        window.addEventListener('message', (event) => {
            console.log(`I'm kaoshi and I heard an event~~~~~~~~~`, event);

            const isAnEventWithType = event.data && event.data.type && typeof event.data.type === 'string';
            if (!isAnEventWithType) {
                console.log('This event has no type');
                return;
            }

            if (event.data.type !== 'unified_cognito_cb' && event.source !== window) {
                console.error(`Got an event from an unknown resource, ${event.source}.`, event);
                return;
            }

            // const isAMessageWeListenTo = event.data.type.startsWith('AUTO_FILLER');
            // if (!isAMessageWeListenTo) {
            //     console.log('app.vue is ignoring event ', event.data.type);
            //     return;
            // }

            const isAMessageWeAreSending = event.data.type.startsWith('AUTO_FILLER_RESPONSE');
            if (isAMessageWeAreSending) {
                console.log('Not listening to event ', event.data.type);
                return;
            }

            if (event.data.type === 'AUTO_FILLER_GET_DATA') {
                // @todo fix to use .then
                vm.result = FormFillerService.dispatchFormFillerUpdate({
                    data: event.data,
                    origin: event.data.type,
                });
            }

            if (event.data.type === 'AUTO_FILLER_PASSWORD_RESET') {
                FormFillerService.resetMasterPass({
                    data: event.data,
                    origin: event.data.type,
                });
            }

            if (event.data.type === 'AUTO_FILLER_SEND_PROBLEM_REPORT') {
                FormFillerService.sendProblemReport({
                    data: event.data,
                    origin: event.data.type,
                });
            }

            if (event.data.type === 'AUTO_FILLER_STORE_DATA') {
                FormFillerService.storeEncryptedData(event.data, event.data.type)
                .then((response) => {
                    // @todo: remove log
                    console.log('Sending response ', response);
                    window.postMessage(response, '*')
                });
            }

            if (event.data.type === 'AUTO_FILLER_GET_BRANDS') {
                FormFillerService.getBrands(event);
            }

            if (event.data.type === 'BACKGROUND-TO-KAOSHI-PING') {
                console.log("app.vue heard the event " + event.data.type);
            }

            if (event.data.type === 'STICKY_NOTE_GET_PWD_DB') {
                FormFillerService.getPasswordDatabase(event);
            }
        }, false);

        this.loadKaoshiCountries();
        this.getRibbon();
    }

    function getComputed() {
        // eslint-disable-next-line no-use-before-define
        return {
            ...mapGetters([
                'isUserAuthenticated',
            ]),
            userOnSecurePage,
            dataOnlyPage,
            showMobileViewer,
            ribbon: {
                get() {
                    return this.$store.state.ribbon;
                },
                set(v) {
                    this.$store.dispatch('updateRibbon', v);
                },
            },
        };

        function showMobileViewer() {
            return !process.env.MIX_ALLOW_CLOSE_MOBILE_COMPATABILITY_MESSAGE;
        }
    }

    /**
     * A list of pages that are deemed "not secure".
     *
     * 1. A page could be "not secure" but have "requiresAuth:true";
     * 2. A page that is "not secure" does not have a left-hand (current UI) menu;
     * 3. This does not seem to look at the route meta.
     *
     * @todo Determine if this function should use the route meta.
     *
     * @returns {boolean}
     */
    function userOnSecurePage() {
        this.isOnSecurePage = ![
            'login',
            'referral-page',
            'tfa-confirm',
            'sign-up',
            'referral-sign-up',
            'not-found',
            'password-reset',
            'password-reset-confirm',
            'password-reset-instructions',
            'user-confirmation-link-confirm',
            'user-confirmation-link-resend',
            'user-confirmation-link-instructions',
            'maintenance',
            'unregistered-payment-requests',
            'upr-make-payment',
            'upr-status',
            'uprOauthRedirect',
            'uprPisOauthRedirect',
        ].includes(this.$route.name);

        return this.isOnSecurePage;
    }

    /**
     * A data only page does not show the usual chrome (e.g. menu bar, avatar etc).
     */
    function dataOnlyPage() {
        this.isDataOnlyPage = [
            'user-form-filler',
            'provider-data-viewer',
            'unified-reauth'
        ].includes(this.$route.name);

        // console.log(`data only page? ${!!this.isDataOnlyPage}`);
        return !!this.isDataOnlyPage;
    }

    function data() {
        /*
         * NOTE: If you change the MIX_REFRESH_SESSION_CHECK_FREQUENCY you must stop and start any `npm run watch` you
         * are running otherwise Node will not pick up the change and you'll spend time wondering what is happening.
         */
        const sessionCheckFrequency = process.env.MIX_REFRESH_SESSION_CHECK_FREQUENCY * 1000 || 60 * 1000;

        return {
            sessionCheckFrequency,
            userNotifiedAboutSessionExpiring: false,
            isOnSecurePage: false,
            overlay: false,
        };
    }
</script>

<style scoped>
    #BgImg {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        min-width: 50%;
        min-height: 50%;
        opacity: 0.05;
    }

    #BgImgContainer {
        position: fixed;
        bottom: 0;
        left: -50%;
        width: 200%;
        height: 200%;
        background-color: #f8f8fd;
        z-index: -1;
    }

</style>
